/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Locations/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import DataVaxiomSysOrganizationsLocationsSelect from 'DesignSystem/DataVaxiomSysOrganizationsLocationsSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Locations({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/Locations"
  
}) {
let tabSelectedStatementsLocationIdsValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.statements.location_ids',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<DataVaxiomSysOrganizationsLocationsSelect
  viewPath={`${viewPath}/DataVaxiomSysOrganizationsLocationsSelect`}
 data="tab.selected.statements.location_ids"
 value={tabSelectedStatementsLocationIdsValueData}
 onChange={onChange}
/>
{children}
</React.Fragment>)
}